import { boot } from "./startup/boot"
await boot()